import React, { useState, useEffect } from 'react';
import './Header.css';
import {hard, setMute} from './index'

import volumeup from './Images/audio-speaker-on.svg';
import mute from './Images/no-sound.svg';
import warning from './Images/info 1.svg';
import lang from'./Images/language 4.svg';
import max from './Images/maximize.svg';
import min from './Images/minimize.svg';
import step from './Images/bar-chart.svg';
import { arviewerLink } from '.';
import reload from './Images/reloading.png';
import arViewer from './Images/augmented-reality 1.svg';
import allhdware from './Images/hdware.svg';
import next from './Images/Left.svg';

function Header({setIsVisiblezz,isVisiblezz,setIsImageVisible, isImageVisible }) {
  const [isVolumeOn, setIsVolumeOn] = useState(true);
  const [isOpenInFull, setIsOpenInFull] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [numViews, setNumViews] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [hardData, setHardData] = useState({});
  
  
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const imagePaths = [
    'https://i.ibb.co/Ss6rg7b/link-2.png ',
    'https://i.ibb.co/B6LFnGn/Pillow-01.png',
    
  ];
  // useEffect(() => {

  //  setHardData(hard);

  //   console.log("hmmmmm",hardData)
  // }, );
  useEffect(() => {
    // Handle loading and displaying of images here
    if (isImageVisible) {
      const image = new Image();
      image.src = imagePaths[currentImageIndex];
      image.onload = () => {
        // Display the image when it's loaded
        setIsImageVisible(true);
      };
    } else {
      // Hide the image
      setIsImageVisible(false);
    }
  }, [isImageVisible, currentImageIndex]);

  const handleNextImage = () => {
    // Move to the next image in the array
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imagePaths.length);
    // Show the image
    setIsImageVisible(true);
  
  };


  const handleVolumeToggle = () => {
    setIsVolumeOn(!isVolumeOn);
    console.log( "volume btn is clicked",isVolumeOn)
    setMute(isVolumeOn);
  };

  const handleOpenInFull = () => {
    setIsOpenInFull(!isOpenInFull);
  };

  const handleInfoIconClick = () => {
    if (isPopupOpen) {
      // Close the popup if it's open
      setIsPopupOpen(false);
    } else {
      // Open the popup if it's closed
      setIsPopupOpen(true);
    }
  };
  
  if (!isVisiblezz) {
    return null;
  }
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const renderHardwareItems = () => {
    if(hardData == undefined) return;
    return Object.entries(hardData).map(([key, value], index) => {
      const imageSrc = `./${key}.png`;
      return (
        <li key={key}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={imageSrc} className="Hardware-Image" />
            <span style={{ marginLeft: '10px' }}>
              {key}: {value}
            </span>
          </div>
        </li>
      );
    });
  };
  const handleReload = () => {
    window.location.reload(); 
    // window.location.href = 'https://example.com';
  };

  const arViewerLoader = () => {
    if (arviewerLink) {
      const newTab = window.open(arviewerLink, '_blank');
      newTab.focus();
    }
    };  


  return (
    <div className="Head-Container">
  

      {isImageVisible && (
        <div className="image-container">
          <img
            src={imagePaths[currentImageIndex]}
            alt="Displayed Image"
            className="Displayed-Image"
          />
        </div>
      )}
{/* <div className='btngrp'><button className="reloadbtn"  onClick={handleReload}>
          <img src={reload} className="reload"  />
          </button>
          <button className="reloadbtn"   onClick={arViewerLoader}>
          <img src={arViewer} className="reload" />
          </button>     </div> */}


      {isPopupOpen && (
        <div className="Popup-Container">
               <h2 style={{paddingTop:"10px",paddingLeft:"20px"}}> Tools</h2>
          <div className="Popup-Content">
     
            <div className="Close-Button" onClick={handleClosePopup}>
              X
            </div>
            {/* <ul style={{ listStyleType: 'none', padding: 0 }}>
              {renderHardwareItems()}
            </ul> */}
     {/* <img src={allhdware} className="hdware" /> */}
          </div>
        </div>
      )}


            <div className="button-container">
        <button className="volume" onClick={handleVolumeToggle}>
          {isVolumeOn ? (
            // <VolumeUpIcon sx={{ fontSize: 30 }} />
      <img src={volumeup} style={{ width:"30px" }}/>
          ) : (
            <img src={mute} style={{ width:"30px" }}/>
          )}
        </button>

        {/* <button className="info" onClick={handleInfoIconClick}>
        <img src={warning} style={{ width:"20px" }}/>
        </button>
        <button className="lang">
        <img src={lang} style={{ width:"20px" }}/>
        </button> */}

      </div>

{/* <div style={{marginTop:"80px"}}>
<button className="next" onClick={handleNextImage}>
          <img src={next} style={{ width: '60px' }} alt="Next Image" />
        </button>
        <button className="toggle-image" onClick={() => setIsImageVisible(!isImageVisible)}>
  {isImageVisible ? 'OFF' : 'ON'}
</button>

</div> */}

{/* <div>
        {isImageVisible && (
          <img
            src={imagePaths[currentImageIndex]}
            alt="Displayed Image"
            className="Displayed-Image"
          />
        )}
      </div> */}
      <div>

      <img
         src=" https://i.ibb.co/dQ9HBwq/screw-1.png"
    
        alt="Info Icon"
        className="Info-Icon"
        onClick={handleInfoIconClick}
      />
</div>
      {/* <div className="zoom" style={{ width: '100%', height: '100%' }}>
        <button className="zoom-button" onClick={handleOpenInFull}>
          {isOpenInFull ? (
          <img src={max} style={{ width:"30px" }}/>
          ) : (
            <img src={min} style={{ width:"30px" }}/>
          )}
        </button>
      </div>
      <div className="step" style={{ width: '100%', height: '100%' }}>
        <button className="step-button" >
       
          <img src={step} style={{ width:"30px" }}/>
      
        </button>
      </div> */}

      {/* {isPopupOpen && (
        <div >
          <div >
            <div className="popup-square">
              <img src={"https://i.ibb.co/0jdFXBP/Group-58067.png"} alt="Model" />
              <h3>ForkLift</h3> 
              <p>Number of Views: {numViews}</p>
              <p>Total Step Count: {totalCount}</p>
            </div>
            <button className="close-button" onClick={handleClosePopup}>
              Close
            </button>
          </div>
        </div>
      )} */}


    </div>

  );
}
const handleToggleImage = (setIsImageVisible, isImageVisible) => {
  // Toggle image visibility
  setIsImageVisible(!isImageVisible);
};
export { handleToggleImage };
export default Header;
